export default "__VITE_ASSET__CbGtNeFD__"